import React, { useReducer, useEffect, useContext, useRef} from "react";
import checklistContext from "./checklistContext";
import {addChecklist, getAllChecklists, updateChecklist, deleteChecklist, getAllChecklistsReg, addChecklistReg, updateChecklistReg, getChecklistByID, getChecklistCorriendoByActivoID, endChecklistReg, getTDocsAssociated, associateNroCheckToODT, getAllChecklistsRegByFilter, addFiles, deleteFilesByCampoAndCk, getChecklistsAllowed} from "../../api/checklist.js";
import checklistReducer from "./checklistReducer";

import { ACTUALIZAR_LIST_CHECKLIST, ACTUALIZAR_LIST_CHECKLISTREGS, MODIFICAR_FILTROS_ESTADOS, MODIFICAR_FILTROS_RANGO } from "./checklistActions.js";

import { SocketContext } from "../socket/socket.js";
import authContext from "../authentication/authContex.js";
import { CHECKLISTStates } from "../../utils/states.js";
import moment from "moment";
import { MODIFICAR_FILTROS } from "../activoContex/activoActions.js";
import { deepEqual, filtrosToString } from "../../utils/funciones.js";
import { getUsersInGroupV } from "../../api/user.js";

const ChecklistState = props =>{

    const server = useContext(SocketContext);

    const ahContext = useContext(authContext)
    const {usuario,verificarTenant} = ahContext;
    const userRef = useRef(usuario);

    const initialState = {
        checklistList: [],
        checklistRegList: null,
        filtrosRango:{
            fecAlt: {
                desde: new Date(moment(new Date).subtract(124, 'days')),
                hasta: new Date(moment(new Date())),
            },
            fecVencimientoDesde: new Date(moment(new Date).add(-365, 'days')),
            fecVencimientoHasta: new Date(moment(new Date).add(365, 'days')),
            fecCompletadoHasta: new Date(moment(new Date).add(365, 'days')),
            deliveryDate: new Date(moment(new Date).add(30, 'days'))
        },
        filtrosEstado: {
            statesChecklist: CHECKLISTStates,
            activos: []
        },
        cargandoChecklistRegs:false
     };

    const [state, dispatch] = useReducer(checklistReducer, initialState);

    const actualizarChecklistList = async () => {
        try{
            let resp;

            let cksAllowed = userRef.current.checklistsAllowed;
            if(cksAllowed && cksAllowed.length > 0) resp = await getChecklistsAllowed(cksAllowed);
            else resp = await getAllChecklists();
            
            const checklist = resp.data.data;

            dispatch({
                type: ACTUALIZAR_LIST_CHECKLIST,
                payload: checklist
            });
            return checklist;
        }catch(err){
            console.log(err)
            return err;
        }
    };

    const agregarChecklist = async (dato, file, file2) => {
        try{
            let ckModelated = {...dato, hasImages: (file || file2) ? true : false};
            const resp = await addChecklist(ckModelated);
            if(file){
                ckModelated.hasImages = true;
                if(file != 'delete') agregarArchivos(dato, 'imgCtrls', file);
            }
            if(file2){
                ckModelated.hasImages = true;
                if(file2 != 'delete') agregarArchivos(dato, 'img2Ctrls', file2);
            }
            const checklist = resp.data.data;
            actualizarChecklistList();
            return checklist;
        }catch(err){
            console.log("error en agregarChecklist de checklistState 44");
            console.log(err);
            if (err.response.data.code == 'DUPLICATEKEY') return err.response.data.code;
            else return null;
        }
    };
    
    const modificarChecklist = async (dato, file, file2) => {
        try{
            let ckModelated = {...dato};
            if(file){
                if(ckModelated.hasImages && !ckModelated.imgUrl2) ckModelated.hasImages = false;
                deleteFilesByCampoAndCk(dato.codigo, 'imgCtrls');
                if(file != 'delete'){
                    ckModelated.hasImages = true;
                    agregarArchivos(dato, 'imgCtrls', file);
                    ckModelated.imgUrl = true;
                } 
            }
            if(file2){
                if(ckModelated.hasImages && !ckModelated.imgUrl) ckModelated.hasImages = false;
                deleteFilesByCampoAndCk(dato.codigo, 'img2Ctrls');
                if(file2 != 'delete'){
                    ckModelated.hasImages = true;
                    agregarArchivos(dato, 'img2Ctrls', file2);
                    ckModelated.imgUrl2 = true;
                } 
            }
            const resp = await updateChecklist(ckModelated);
            const checklist = resp.data.data;
            return checklist;
        }catch(err){
            console.log(err)
            return err.response.data;
        }
    }

    const eliminarChecklist = async (checklist) => {
        try{
            const resp = await deleteChecklist(checklist);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    /*Checklist Registros*/
    const actualizarChecklistRegList = async () => {
        try{
            const resp = await getAllChecklistsReg();
            const checklist = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_CHECKLISTREGS,
                payload: checklist
            });
            return checklist;
        }catch(err){
            console.log(err)
            return err;
        }
    };

    const iniciarFiltrosChecklistRegs = async (usuarioParam = "", filtrosRango = initialState.filtrosRango) => {
        try {
            //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
            const filtrosString = filtrosToString(filtrosRango);

            let userToUse = usuarioParam ? usuarioParam : usuario;

            //Obtengo los usuarios que puede ver el userToUse mediante su campo groupV
            const respUsuarios = await getUsersInGroupV(userToUse._id);
            
            //Creo un arreglo de userNames y luego si no se encuentra el userToUse en sesion lo agrego
            const usuarios = [...new Set(respUsuarios.data.data.map((u) => u.user.userName))];

            if(!usuarios.includes(userToUse.userName)) usuarios.push(userToUse.userName);

            const filtrosEstado = { ...initialState.filtrosEstado, statesChecklist: CHECKLISTStates, userName: usuarios, activos: userToUse.activosAllowed.map(a => a.value)};

            dispatch({
                type: MODIFICAR_FILTROS,
                payload: {
                    filtrosEstado: filtrosEstado,
                    filtrosRango: filtrosRango
                }
            });

            let res = await getAllChecklistsRegByFilter(userToUse._id, filtrosString);
            
            dispatch({
                type: ACTUALIZAR_LIST_CHECKLISTREGS,
                payload: res.data.data
            });

            return true;
        } catch (error) {
            console.log(error);
            console.log("Error a la hora de iniciar filtros");
        }
   }

   //Modifica los filtros de rango y trae los tDocs acorde a los parametros enviados
    const modificarFiltrosRango = async (userId , filtrosRango) => {
        const filtrosString = filtrosToString(filtrosRango);

        let areEquals = deepEqual(state.filtrosRango, filtrosRango);

        //Si se detectaron cambios en los filtros por rango, vuelven a solicitarse los documentos al backend.
        if(!areEquals){
            //Probando, esta iba despues de declarar listaRequerimientos cuando SET_TDOCS no existia.
            dispatch({
                type: MODIFICAR_FILTROS_RANGO,
                payload: { filtrosRango }
                // payload: { filtrosRango, listaRequerimientos }
            })

            let res = await getAllChecklistsRegByFilter(userId, filtrosString);
            
            dispatch({
                type: ACTUALIZAR_LIST_CHECKLISTREGS,
                payload: res.data.data
            });
        }
    };

    //Modifica los filtros de estado
    const modificarFiltrosEstado = (filtrosEstados) => {
        dispatch({
            type: MODIFICAR_FILTROS_ESTADOS,
            payload: filtrosEstados
        })
    };

    const filtrarChecklistRegistrados = (lista, filtrosEstado, filtrosRango = {}) => {
        try {
            let listaFiltrada;

            if (!lista || lista === undefined) return undefined;

            listaFiltrada = lista.slice();        
            
            listaFiltrada = listaFiltrada?.filter(item => (filtrosEstado.activos.length > 0 ? filtrosEstado.activos.includes(item.codActivo) : true));

            listaFiltrada = listaFiltrada.filter((c) => {
                return ((filtrosEstado.statesChecklist.length == 2 ? true : filtrosEstado.statesChecklist[0] == "CTRLFALLIDOS" ? c.controles.some(c => c.checked == 'negative') : filtrosEstado.statesChecklist[0] == "CTRLEXITOSOS" ? !c.controles.some(c => c.checked == 'negative') : false))
            })

            return listaFiltrada;
        } catch (error) {
            console.log("error en filtrarChecklistRegistrados");
            console.log(error);
            return [];
        }
    }

    const agregarChecklistReg = async (dato) => {
        try{
            const resp = await addChecklistReg(dato);
            const checklistReg = resp.data.data;
            actualizarChecklistRegList();
            return checklistReg;
        }catch(err){
            console.log("error en agregarChecklistReg de checklistRegState 44");
            console.log(err);
            if (err.response.data.code == 'DUPLICATEKEY') return err.response.data.code;
            else return null;
        }
    };

    const modificarChecklistReg = async (dato) => {
        try{
            const resp = await updateChecklistReg(dato);
            const checklist = resp.data.data;
            return checklist;
        }catch(err){
            console.log(err)
            return err.response.data;
        }
    }
    
    const finalizarChecklistReg = async (dato,user) => {
        try{
            const resp = await endChecklistReg(dato,user);
            const checklist = resp.data.data;
            return checklist;
        }catch(err){
            console.log(err)
            return err.response.data;
        }
    }
    
    const getCheckByID = async(checkID) =>{
        try {
            let res = await getChecklistByID(checkID);
            return res;
        } catch (error) {
            console.log(error.message);
            return error.message;
        }
    } 

    const getChecklistRunningByActivoID = async (activoID) => {
        try {
            const res = await getChecklistCorriendoByActivoID(activoID);
            if(res.data.modelado) return res.data.modelado;
            else return false;
        } catch (error) {
            console.log("Error en getChecklistRunningByActivoID");
            console.log(error);
        }
    }

    const getTDocsWithCKAssociated = async(checkID, activoID) => {
        try {
            let res = await getTDocsAssociated(checkID, activoID);
            return res.data.data;
        } catch (error) {
            console.log(error);
            return error.message;
        }
    }

    const associateNroCKtoODT = async(relationId, checkNro) => {
        try {
            let res = await associateNroCheckToODT(relationId,checkNro);
            return res.data.data;
        } catch (error) {
            console.log("Error en associateNroCKtoODT en checklistState");
            console.log(error);
        }
    }

    /* 
        Agrega archivos a un requerimiento.
            Donde req es el requerimiento.
                  files son los archivos.
    */
    const agregarArchivos = async (ck, campo, file) => {
        try {
            const formData = new FormData();
            formData.append(`files`, file);
            formData.append('prefijo', `${ck.codigo}-${campo}`);
            await addFiles(formData);
            return true;
        } catch (error) {
            console.log("Error en agregar archivos");
            console.log(error);
            throw new Error(`Error al guardar archivos del requerimiento ${ck.codigo + "-" + campo}`)
        }
    }
    
    /* 
        Disparadores que sincronizan la lista de checklists ante la modificacion de uno.
    */
    useEffect(() => {
        if(server){
            //TDoc Nuevo
            server.on('checklistMod', ({tenantId}) => {
                const update = verificarTenant(tenantId);
                if(update){
                    console.log("RealTimeServer indico que un checklist a sido modificado, actualizando lista de Checkslist...");
                    actualizarChecklistList();
                } 
                else console.log("No corresponde actualizar checklist list");
                
            });
            
            server.on('checklistRegMod', ({tenantId}) => {
                const update = verificarTenant(tenantId);
                if(update){
                    console.log("RealTimeServer indico que un registro de checklist a sido modificado, actualizando lista de CheckslistReg...");
                    actualizarChecklistRegList();
                } 
                else console.log("No corresponde actualizar checklistreg list");
            });
            return () => server.off('checklistMod');
        }
    },[server]);

    useEffect(() => {
        userRef.current = usuario;
        if(usuario != null){
            actualizarChecklistList();
            iniciarFiltrosChecklistRegs();
        }
    },[usuario])


    return(
        <checklistContext.Provider
            value={{
                initialState: initialState,
                filtrosRango: state.filtrosRango,
                checklistList: state.checklistList,
                filtrosEstado: state.filtrosEstado,
                checklistRegList: state.checklistRegList,
                cargandoChecklistRegs: state.cargandoChecklistRegs,
                actualizarChecklistList:actualizarChecklistList,
                agregarChecklist,
                getCheckByID,
                modificarChecklist,
                eliminarChecklist,
                agregarChecklistReg,
                modificarChecklistReg,
                finalizarChecklistReg,
                actualizarChecklistRegList:actualizarChecklistRegList, 
                getChecklistRunningByActivoID,
                getTDocsWithCKAssociated,
                associateNroCKtoODT,
                iniciarFiltrosChecklistRegs,
                modificarFiltrosRango,
                modificarFiltrosEstado,
                filtrarChecklistRegistrados
            }}
        >
            {props.children}
        </checklistContext.Provider>
    )

}

export default ChecklistState;